import { Component, NgModule, NgModuleFactory, Input, Compiler, OnInit, ElementRef } from '@angular/core';
import { DirectivesModule } from '../../directives/directives.module';
import { AppState } from '../../config/state';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the CoHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// template: `<div class='fakebody'><div class='fakepage'><ng-container *ngComponentOutlet="dynamicComponent; ngModuleFactory: dynamicModule;"></ng-container></div></div>`,
@Component({
  selector: 'co-html',
  templateUrl: 'co-html.html',
})
export class CoHtmlComponent implements OnInit{
  dynamicComponent;
  dynamicModule: NgModuleFactory<any>;
  parsedHtml: string = "";
  @Input() html: string = "";
  @Input() className: string = "";
  @Input() cssRules: any = {};
  pageVariables: any = {locationName: ''}
  constructor(private compiler: Compiler, private el: ElementRef, private state : AppState, private sanitizer: DomSanitizer) {
    if (this.state.branchInformation) this.pageVariables.locationName = this.state.branchInformation.name;
  }
  ngOnInit() {
    this.templateVariables(this.html? this.html : "").then(res=>{
      this.parsedHtml = res;
      // this.dynamicComponent = this.createNewComponent(res, this.className);
      // this.dynamicModule = this.compiler.compileModuleSync(this.createComponentModule(this.dynamicComponent));
    })
  }
  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
        // this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }
  protected createComponentModule (componentType: any) {
    @NgModule({
      imports: [DirectivesModule],
      declarations: [
        componentType
      ],
      entryComponents: [componentType]
    })
    class RuntimeComponentModule{
    }
    // a module for just this Type
    return RuntimeComponentModule;
  }

  protected createNewComponent (html, className) {
    let template = `<div class="${className}">${this.sanitizer.bypassSecurityTrustHtml(html)}</div>`
    @Component({
      selector: 'dynamic-component',
      template: template
    })
    class DynamicComponent implements OnInit{
       text: any;

       ngOnInit() {
       }
    }
    return DynamicComponent;
  }

  async templateVariables(string){
    if (string.length <= 0) return "";
    let words = string.split(' ');
    let outWords = []
    words.forEach(word => {
      if(word.match(/{{(.*?)}}/g) ){
        let match = word.match(/{{(.*?)}}/g)[0].substr(2);
        match = match.substr(0, match.length - 2)
        if (this.pageVariables[match]) word = this.pageVariables[match];
        outWords.push(word);
      } else {
        outWords.push(word);
      }
    });
    return outWords.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/components/co-html/co-html.ts